import { useState } from 'react';
import { AxiosPublic } from '../utils/axios';

export const useGetOrganization = () => {
  const [isFetching, setFetching] = useState(false);
  const [orgData, setOrgData] = useState<any>();
  return {
    isFetching,
    orgData,
    getOrganization: async id => {
      try {
        setFetching(true);
        const response = await AxiosPublic.get(`/organizations/${id}`);
        setFetching(false);
        setOrgData(response);
        return response;
      } catch (e) {
        setFetching(false);
      }
    },
  };
};
